import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const MusicNoteMuteIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 15;
  const color = props.color || 'black';
  return <Icon name={'music-note-mute'} size={size} color={color} />;
};

export default React.memo(MusicNoteMuteIcon);
